import auth from "app/auth/store/auth.slice";
import userSetup from "app/user-setup/store/userSetup.slice";
import trackingApp from "./trackingApp";
import crlApp from "app/main/crl/store";
import ediApp from "app/main/edi/store";
import variaveisApp from "app/main/configuracoes/views/Variaveis/store";
import ocorrenciasApp from "app/main/configuracoes/views/Ocorrencias/store";
import triagemApp from "app/main/triagem/store/slices/triagem.slice";
import buscaDeInsumosApp from "app/main/insumos/store";
import acareacoesApp from "app/main/acareacoes/store";
import comprovantesApp from "app/main/comprovantes/store";
import acessosApp from "app/main/configuracoes/views/Acessos/store";
import matrizConfigApp from "app/main/configuracoes/views/Matriz/store";
import transportadorasApp from "app/main/configuracoes/views/Transportadoras/store";
import kitColetaApp from "app/main/kitcoleta/store";
import torrePesadosApp from "app/main/torre-pesados/store";
import torreLmlApp from "app/main/torre-lml/store";
import torreMiniHubApp from "app/main/torre-minihub/store";
import torreFracionadosApp from "app/main/torre-fracionados/store";
import listaPedidosApp from "app/main/listaPedidos/store";
import listaPedidosLMLApp from "app/main/listaPedidosLML/store";
import listaPedidosMiniHubApp from "app/main/listaPedidosMiniHub/store";
import listaPedidosFracionadosApp from "app/main/listaPedidosFracionados/store";
import relatorioComprovantesApp from "app/main/relatorio-comprovantes/store";
import { insumosApi } from "app/main/insumos/store/actions";
import { actionsApi } from "app/main/configuracoes/store/actionsApi";
import { combineReducers } from "@reduxjs/toolkit";

const rootReducer = combineReducers({
  auth,
  userSetup,
  trackingApp,
  variaveisApp,
  ocorrenciasApp,
  triagemApp,
  crlApp,
  ediApp,
  buscaDeInsumosApp,
  acareacoesApp,
  comprovantesApp,
  acessosApp,
  matrizConfigApp,
  transportadorasApp,
  kitColetaApp,
  torrePesadosApp,
  torreLmlApp,
  torreMiniHubApp,
  torreFracionadosApp,
  listaPedidosApp,
  listaPedidosLMLApp,
  listaPedidosMiniHubApp,
  listaPedidosFracionadosApp,
  relatorioComprovantesApp,
  [actionsApi.reducerPath]: actionsApi.reducer,
  [insumosApi.reducerPath]: insumosApi.reducer,
});

export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
